/**
 * Clipboard utilities
 */

/**
 * Copy text to the clipboard. Falls back to a hidden textarea + execCommand
 * when the async Clipboard API isn't available (e.g. non-secure contexts -
 * plain HTTP on a non-localhost host - where `navigator.clipboard` is undefined).
 */
export function copyToClipboard(text: string): void {
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(text).catch(() => fallbackCopy(text));
    return;
  }
  fallbackCopy(text);
}

function fallbackCopy(text: string): void {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  try {
    document.execCommand('copy');
  } catch {
    // Nothing more we can do - clipboard access isn't available in this context.
  } finally {
    document.body.removeChild(textarea);
  }
}
